import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconKeep.tsx
const OutlinedFilledKeep = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m660-474 86 77v95H527v238l-47 47-47-47v-238H215v-95l80-77v-314h-50v-94h465v94h-50v314Z" })
});
const OutlinedKeep = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m660-474 86 77v95H527v238l-47 47-47-47v-238H215v-95l80-77v-313h-50v-94h465v94h-50v313Zm-317 77h268l-46-42v-348H389v348l-46 42Zm134 0Z" })
});
const RoundedFilledKeep = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M660-790v316l72 63q7 7 10.5 15.6 3.5 8.59 3.5 17.56v29.16q0 19.68-14.12 33.18Q717.75-302 698-302H527v230q0 19.75-13.68 33.37Q499.65-25 479.82-25 460-25 446.5-38.63 433-52.25 433-72v-230H262q-19.75 0-33.37-13.58Q215-329.17 215-348.86v-29.17q0-8.97 3-17.47 3-8.5 10-15.5l67-63v-316h-20q-13.75-5-21.87-16.68-8.13-11.67-8.13-27.5 0-19.82 13.63-33.32Q272.25-881 292-881h370q19.75 0 33.88 13.68Q710-853.65 710-833.82q0 15.82-8.62 27.32Q692.75-795 680-790h-20Z" })
});
const RoundedKeep = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M660-790v316l72 63q7 7 10.5 15.6 3.5 8.59 3.5 17.56v29.16q0 19.68-14.12 33.18Q717.75-302 698-302H527v230q0 19.75-13.68 33.37Q499.65-25 479.82-25 460-25 446.5-38.63 433-52.25 433-72v-230H262q-19.75 0-33.37-13.58Q215-329.17 215-348.86v-29.17q0-8.97 3-17.47 3-8.5 10-15.5l67-63v-316h-20q-13.75-5-21.87-16.68-8.13-11.67-8.13-27.5 0-19.82 13.63-33.32Q272.25-881 292-881h370q19.75 0 33.88 13.68Q710-853.65 710-833.82q0 15.82-8.62 27.32Q692.75-795 680-790h-20ZM343-397h268l-46-42v-348H389v348l-46 42Zm134 0Z" })
});
const SharpFilledKeep = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m660-474 86 77v95H527v238l-47 47-47-47v-238H215v-95l80-77v-314h-50v-94h465v94h-50v314Z" })
});
const SharpKeep = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m660-474 86 77v95H527v238l-47 47-47-47v-238H215v-95l80-77v-313h-50v-94h465v94h-50v313Zm-317 77h268l-46-42v-348H389v348l-46 42Zm134 0Z" })
});
const componentMap = {
	outlined: OutlinedKeep,
	"outlined-fill": OutlinedFilledKeep,
	rounded: RoundedKeep,
	"rounded-fill": RoundedFilledKeep,
	sharp: SharpKeep,
	"sharp-fill": SharpFilledKeep
};
const IconKeep = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconKeep };